import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";

export class DateUtil {
	static weekdaysSubject = new Subject<any>();
	static weekdays = null;

	static getWeekDay(date: Date): string {
		return DateUtil.getWeekDayString(date.getDay());
	}

	static getWeekDayString(weekDay: number): string {
		if (weekDay === 0) {
			return 'SUN';
		} else if (weekDay === 1) {
			return 'MON';
		} else if (weekDay === 2) {
			return 'TUE';
		} else if (weekDay === 3) {
			return 'WED';
		} else if (weekDay === 4) {
			return 'THR';
		} else if (weekDay === 5) {
			return 'FRI';
		} else if (weekDay === 6) {
			return 'SAT';
		} else {
			return 'ERR';
		}
	}

	static get12Hours(date: Date): number {
		if (date.getHours() < 12) {
			return date.getHours();
		} else {
			return date.getHours() - 12;
		}
	} 

	static loadWeekDays(translateService: TranslateService): Observable<any> {
		if (!DateUtil.weekdays) {

		}
		translateService.get([
			'common.weekdays.SUN',
			'common.weekdays.MON',
			'common.weekdays.TUE',
			'common.weekdays.WED',
			'common.weekdays.THR',
			'common.weekdays.FRI',
			'common.weekdays.SAT'
		]).subscribe((messages: any) => {
			const weekdays = DateUtil.weekdays = {};

			weekdays['SUN'] = messages['common.weekdays.SUN'];
			weekdays['MON'] = messages['common.weekdays.MON'];
			weekdays['TUE'] = messages['common.weekdays.TUE'];
			weekdays['WED'] = messages['common.weekdays.WED'];
			weekdays['THR'] = messages['common.weekdays.THR'];
			weekdays['FRI'] = messages['common.weekdays.FRI'];
			weekdays['SAT'] = messages['common.weekdays.SAT'];
		});

		return DateUtil.weekdaysSubject;
	}

	static getWeekDays() {
		DateUtil.weekdaysSubject.next(DateUtil.weekdays);
	}
}
